import type { UploadRawFile } from 'element-plus'
import { ref } from 'vue'

import { normalizeImage } from '@/lib/adapters/image.adapter'
import { handleErrorMessage } from '@/lib/helpers/error.helpers'
import { request } from '@/lib/services'
import type { ProcessableImageType } from '@/lib/types/common.types'
import { useErrorStore } from '@/stores/error'

export const useUploadTempImageRequest = () => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)
  const errorStore = useErrorStore()
  const uploadedImage = ref<null | ProcessableImageType>(null)

  const uploadImage = async (image: Blob | UploadRawFile) => {
    try {
      isLoading.value = true
      error.value = null
      const response = await request.post('/v2/image-uploads', { image }, { isFormData: true })
      uploadedImage.value = normalizeImage(response.data)
    } catch (e: unknown) {
      errorStore.setError(handleErrorMessage(e))
      error.value = e as Error
    } finally {
      isLoading.value = false
    }
  }

  return {
    image: uploadedImage,
    uploadImage,
    isLoading,
    error,
  }
}
